/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as AuthedRouteImport } from './app/routes/_authed'
import { Route as AuthRouteImport } from './app/routes/auth'
import { Route as ShareRouteImport } from './app/routes/share'
import { Route as AuthedIndexRouteImport } from './app/routes/_authed/index'
import { Route as AuthedCompanySlugRouteImport } from './app/routes/_authed/$companySlug'
import { Route as AuthedNoSidebarRouteImport } from './app/routes/_authed/_noSidebar'
import { Route as AuthedDiscoverRouteImport } from './app/routes/_authed/discover'
import { Route as AuthedProfileRouteImport } from './app/routes/_authed/profile'
import { Route as AuthIndexRouteImport } from './app/routes/auth/index'
import { Route as AuthAccountsRouteImport } from './app/routes/auth/accounts'
import { Route as AuthJoinRouteImport } from './app/routes/auth/join'
import { Route as AuthSignupRouteImport } from './app/routes/auth/signup'
import { Route as OnboardingCompanySetupRouteImport } from './app/routes/onboarding/company-setup'
import { Route as AuthedCompanySlugIndexRouteImport } from './app/routes/_authed/$companySlug/index'
import { Route as AuthedCompanySlugSettingsRouteImport } from './app/routes/_authed/$companySlug/_settings'
import { Route as AuthedCompanySlugAdminRouteImport } from './app/routes/_authed/$companySlug/admin'
import { Route as AuthedCompanySlugIntelligenceRouteImport } from './app/routes/_authed/$companySlug/intelligence'
import { Route as AuthedCompanySlugTasksRouteImport } from './app/routes/_authed/$companySlug/tasks'
import { Route as AuthedNoSidebarCompanySlugRouteImport } from './app/routes/_authed/_noSidebar/$companySlug'
import { Route as ShareTenderTokenRouteImport } from './app/routes/share/tender.$token'
import { Route as AuthedCompanySlugAdminIndexRouteImport } from './app/routes/_authed/$companySlug/admin/index'
import { Route as AuthedCompanySlugAdminAccessCreditsRouteImport } from './app/routes/_authed/$companySlug/admin/access-credits'
import { Route as AuthedCompanySlugAdminCategoryImagesRouteImport } from './app/routes/_authed/$companySlug/admin/category-images'
import { Route as AuthedCompanySlugAdminClientsRouteImport } from './app/routes/_authed/$companySlug/admin/clients'
import { Route as AuthedCompanySlugAdminFeatureFlagsRouteImport } from './app/routes/_authed/$companySlug/admin/feature-flags'
import { Route as AuthedCompanySlugAdminUsersRouteImport } from './app/routes/_authed/$companySlug/admin/users'
import { Route as AuthedCompanySlugCaselawIndexRouteImport } from './app/routes/_authed/$companySlug/caselaw/index'
import { Route as AuthedCompanySlugHorizonIndexRouteImport } from './app/routes/_authed/$companySlug/horizon/index'
import { Route as AuthedCompanySlugOrganisationsIndexRouteImport } from './app/routes/_authed/$companySlug/organisations/index'
import { Route as AuthedCompanySlugOrganizationsIndexRouteImport } from './app/routes/_authed/$companySlug/organizations/index'
import { Route as AuthedCompanySlugProcurementCalendarIndexRouteImport } from './app/routes/_authed/$companySlug/procurement-calendar/index'
import { Route as AuthedCompanySlugTendersIndexRouteImport } from './app/routes/_authed/$companySlug/tenders/index'
import { Route as AuthedCompanySlugWorkflowsIndexRouteImport } from './app/routes/_authed/$companySlug/workflows/index'
import { Route as AuthedNoSidebarCompanySlugUpgradeRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/upgrade'
import { Route as AuthedCompanySlugSettingsSettingsApiRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/api'
import { Route as AuthedCompanySlugSettingsSettingsCompanyRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/company'
import { Route as AuthedCompanySlugSettingsSettingsIntegrationsRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/integrations'
import { Route as AuthedCompanySlugSettingsSettingsLabelsRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/labels'
import { Route as AuthedCompanySlugSettingsSettingsMcpRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/mcp'
import { Route as AuthedCompanySlugSettingsSettingsNotificationsRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/notifications'
import { Route as AuthedCompanySlugSettingsSettingsProfileRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/profile'
import { Route as AuthedCompanySlugSettingsSettingsRejectionReasonRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/rejection-reason'
import { Route as AuthedCompanySlugSettingsSettingsTeamsRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/teams'
import { Route as AuthedCompanySlugAdminClientsIndexRouteImport } from './app/routes/_authed/$companySlug/admin/clients/index'
import { Route as AuthedCompanySlugAdminClientsClientIdRouteImport } from './app/routes/_authed/$companySlug/admin/clients/$clientId'
import { Route as AuthedCompanySlugAdminProcurementCalendarNewRouteImport } from './app/routes/_authed/$companySlug/admin/procurement-calendar/new'
import { Route as AuthedCompanySlugAdminUsersIndexRouteImport } from './app/routes/_authed/$companySlug/admin/users/index'
import { Route as AuthedCompanySlugCaselawCaselawIdIndexRouteImport } from './app/routes/_authed/$companySlug/caselaw/$caselawId/index'
import { Route as AuthedCompanySlugHorizonItemIdIndexRouteImport } from './app/routes/_authed/$companySlug/horizon/$itemId/index'
import { Route as AuthedCompanySlugOrganisationsOrganizationIdIndexRouteImport } from './app/routes/_authed/$companySlug/organisations/$organizationId/index'
import { Route as AuthedCompanySlugOrganizationsOrganizationIdIndexRouteImport } from './app/routes/_authed/$companySlug/organizations/$organizationId/index'
import { Route as AuthedCompanySlugTendersTenderIdIndexRouteImport } from './app/routes/_authed/$companySlug/tenders/$tenderId/index'
import { Route as AuthedNoSidebarCompanySlugSubscribeIndexRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/subscribe/index'
import { Route as AuthedNoSidebarCompanySlugSubscribeCallbackRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/subscribe/callback'
import { Route as AuthedNoSidebarCompanySlugSubscribeFailedRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/subscribe/failed'
import { Route as AuthedNoSidebarCompanySlugSubscribeOverdueRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/subscribe/overdue'
import { Route as AuthedNoSidebarCompanySlugSubscribeSuccessRouteImport } from './app/routes/_authed/_noSidebar/$companySlug/subscribe/success'
import { Route as AuthedCompanySlugSettingsSettingsSubscriptionIndexRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/subscription/index'
import { Route as AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/subscription/credit-history'
import { Route as AuthedCompanySlugSettingsSettingsUsersIndexRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/users/index'
import { Route as AuthedCompanySlugSettingsSettingsWorkflowsIndexRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/workflows/index'
import { Route as AuthedCompanySlugAdminSourcingEntriesIndexRouteImport } from './app/routes/_authed/$companySlug/admin/sourcing/entries/index'
import { Route as AuthedCompanySlugAdminSourcingOverviewIndexRouteImport } from './app/routes/_authed/$companySlug/admin/sourcing/overview/index'
import { Route as AuthedCompanySlugAdminSourcingReviewIndexRouteImport } from './app/routes/_authed/$companySlug/admin/sourcing/review/index'
import { Route as AuthedCompanySlugAdminSourcingWebsitesIndexRouteImport } from './app/routes/_authed/$companySlug/admin/sourcing/websites/index'
import { Route as AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRouteImport } from './app/routes/_authed/$companySlug/admin/sourcing/websites/$websiteId'
import { Route as AuthedCompanySlugSettingsSettingsUsersUserIdIndexRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/users/$userId/index'
import { Route as AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRouteImport } from './app/routes/_authed/$companySlug/_settings/settings/workflows/$workflowId/index'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareRoute = ShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompanySlugRoute = AuthedCompanySlugRouteImport.update({
  id: '/$companySlug',
  path: '/$companySlug',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNoSidebarRoute = AuthedNoSidebarRouteImport.update({
  id: '/_noSidebar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiscoverRoute = AuthedDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountsRoute = AuthAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJoinRoute = AuthJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const OnboardingCompanySetupRoute = OnboardingCompanySetupRouteImport.update({
  id: '/onboarding/company-setup',
  path: '/onboarding/company-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedCompanySlugIndexRoute = AuthedCompanySlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedCompanySlugRoute,
} as any)
const AuthedCompanySlugSettingsRoute =
  AuthedCompanySlugSettingsRouteImport.update({
    id: '/_settings',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugAdminRoute = AuthedCompanySlugAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedCompanySlugRoute,
} as any)
const AuthedCompanySlugIntelligenceRoute =
  AuthedCompanySlugIntelligenceRouteImport.update({
    id: '/intelligence',
    path: '/intelligence',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugTasksRoute = AuthedCompanySlugTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedCompanySlugRoute,
} as any)
const AuthedNoSidebarCompanySlugRoute =
  AuthedNoSidebarCompanySlugRouteImport.update({
    id: '/$companySlug',
    path: '/$companySlug',
    getParentRoute: () => AuthedNoSidebarRoute,
  } as any)
const ShareTenderTokenRoute = ShareTenderTokenRouteImport.update({
  id: '/tender/$token',
  path: '/tender/$token',
  getParentRoute: () => ShareRoute,
} as any)
const AuthedCompanySlugAdminIndexRoute =
  AuthedCompanySlugAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminAccessCreditsRoute =
  AuthedCompanySlugAdminAccessCreditsRouteImport.update({
    id: '/access-credits',
    path: '/access-credits',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminCategoryImagesRoute =
  AuthedCompanySlugAdminCategoryImagesRouteImport.update({
    id: '/category-images',
    path: '/category-images',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminClientsRoute =
  AuthedCompanySlugAdminClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminFeatureFlagsRoute =
  AuthedCompanySlugAdminFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminUsersRoute =
  AuthedCompanySlugAdminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugCaselawIndexRoute =
  AuthedCompanySlugCaselawIndexRouteImport.update({
    id: '/caselaw/',
    path: '/caselaw/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugHorizonIndexRoute =
  AuthedCompanySlugHorizonIndexRouteImport.update({
    id: '/horizon/',
    path: '/horizon/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugOrganisationsIndexRoute =
  AuthedCompanySlugOrganisationsIndexRouteImport.update({
    id: '/organisations/',
    path: '/organisations/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugOrganizationsIndexRoute =
  AuthedCompanySlugOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugProcurementCalendarIndexRoute =
  AuthedCompanySlugProcurementCalendarIndexRouteImport.update({
    id: '/procurement-calendar/',
    path: '/procurement-calendar/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugTendersIndexRoute =
  AuthedCompanySlugTendersIndexRouteImport.update({
    id: '/tenders/',
    path: '/tenders/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugWorkflowsIndexRoute =
  AuthedCompanySlugWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugUpgradeRoute =
  AuthedNoSidebarCompanySlugUpgradeRouteImport.update({
    id: '/upgrade',
    path: '/upgrade',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsApiRoute =
  AuthedCompanySlugSettingsSettingsApiRouteImport.update({
    id: '/settings/api',
    path: '/settings/api',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsCompanyRoute =
  AuthedCompanySlugSettingsSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsIntegrationsRoute =
  AuthedCompanySlugSettingsSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsLabelsRoute =
  AuthedCompanySlugSettingsSettingsLabelsRouteImport.update({
    id: '/settings/labels',
    path: '/settings/labels',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsMcpRoute =
  AuthedCompanySlugSettingsSettingsMcpRouteImport.update({
    id: '/settings/mcp',
    path: '/settings/mcp',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsNotificationsRoute =
  AuthedCompanySlugSettingsSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsProfileRoute =
  AuthedCompanySlugSettingsSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsRejectionReasonRoute =
  AuthedCompanySlugSettingsSettingsRejectionReasonRouteImport.update({
    id: '/settings/rejection-reason',
    path: '/settings/rejection-reason',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsTeamsRoute =
  AuthedCompanySlugSettingsSettingsTeamsRouteImport.update({
    id: '/settings/teams',
    path: '/settings/teams',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugAdminClientsIndexRoute =
  AuthedCompanySlugAdminClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCompanySlugAdminClientsRoute,
  } as any)
const AuthedCompanySlugAdminClientsClientIdRoute =
  AuthedCompanySlugAdminClientsClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => AuthedCompanySlugAdminClientsRoute,
  } as any)
const AuthedCompanySlugAdminProcurementCalendarNewRoute =
  AuthedCompanySlugAdminProcurementCalendarNewRouteImport.update({
    id: '/procurement-calendar/new',
    path: '/procurement-calendar/new',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminUsersIndexRoute =
  AuthedCompanySlugAdminUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCompanySlugAdminUsersRoute,
  } as any)
const AuthedCompanySlugCaselawCaselawIdIndexRoute =
  AuthedCompanySlugCaselawCaselawIdIndexRouteImport.update({
    id: '/caselaw/$caselawId/',
    path: '/caselaw/$caselawId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugHorizonItemIdIndexRoute =
  AuthedCompanySlugHorizonItemIdIndexRouteImport.update({
    id: '/horizon/$itemId/',
    path: '/horizon/$itemId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugOrganisationsOrganizationIdIndexRoute =
  AuthedCompanySlugOrganisationsOrganizationIdIndexRouteImport.update({
    id: '/organisations/$organizationId/',
    path: '/organisations/$organizationId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugOrganizationsOrganizationIdIndexRoute =
  AuthedCompanySlugOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/organizations/$organizationId/',
    path: '/organizations/$organizationId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugTendersTenderIdIndexRoute =
  AuthedCompanySlugTendersTenderIdIndexRouteImport.update({
    id: '/tenders/$tenderId/',
    path: '/tenders/$tenderId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugSubscribeIndexRoute =
  AuthedNoSidebarCompanySlugSubscribeIndexRouteImport.update({
    id: '/subscribe/',
    path: '/subscribe/',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugSubscribeCallbackRoute =
  AuthedNoSidebarCompanySlugSubscribeCallbackRouteImport.update({
    id: '/subscribe/callback',
    path: '/subscribe/callback',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugSubscribeFailedRoute =
  AuthedNoSidebarCompanySlugSubscribeFailedRouteImport.update({
    id: '/subscribe/failed',
    path: '/subscribe/failed',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugSubscribeOverdueRoute =
  AuthedNoSidebarCompanySlugSubscribeOverdueRouteImport.update({
    id: '/subscribe/overdue',
    path: '/subscribe/overdue',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedNoSidebarCompanySlugSubscribeSuccessRoute =
  AuthedNoSidebarCompanySlugSubscribeSuccessRouteImport.update({
    id: '/subscribe/success',
    path: '/subscribe/success',
    getParentRoute: () => AuthedNoSidebarCompanySlugRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute =
  AuthedCompanySlugSettingsSettingsSubscriptionIndexRouteImport.update({
    id: '/settings/subscription/',
    path: '/settings/subscription/',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute =
  AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRouteImport.update({
    id: '/settings/subscription/credit-history',
    path: '/settings/subscription/credit-history',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsUsersIndexRoute =
  AuthedCompanySlugSettingsSettingsUsersIndexRouteImport.update({
    id: '/settings/users/',
    path: '/settings/users/',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute =
  AuthedCompanySlugSettingsSettingsWorkflowsIndexRouteImport.update({
    id: '/settings/workflows/',
    path: '/settings/workflows/',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugAdminSourcingEntriesIndexRoute =
  AuthedCompanySlugAdminSourcingEntriesIndexRouteImport.update({
    id: '/sourcing/entries/',
    path: '/sourcing/entries/',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminSourcingOverviewIndexRoute =
  AuthedCompanySlugAdminSourcingOverviewIndexRouteImport.update({
    id: '/sourcing/overview/',
    path: '/sourcing/overview/',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminSourcingReviewIndexRoute =
  AuthedCompanySlugAdminSourcingReviewIndexRouteImport.update({
    id: '/sourcing/review/',
    path: '/sourcing/review/',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminSourcingWebsitesIndexRoute =
  AuthedCompanySlugAdminSourcingWebsitesIndexRouteImport.update({
    id: '/sourcing/websites/',
    path: '/sourcing/websites/',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute =
  AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRouteImport.update({
    id: '/sourcing/websites/$websiteId',
    path: '/sourcing/websites/$websiteId',
    getParentRoute: () => AuthedCompanySlugAdminRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute =
  AuthedCompanySlugSettingsSettingsUsersUserIdIndexRouteImport.update({
    id: '/settings/users/$userId/',
    path: '/settings/users/$userId/',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)
const AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute =
  AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRouteImport.update({
    id: '/settings/workflows/$workflowId/',
    path: '/settings/workflows/$workflowId/',
    getParentRoute: () => AuthedCompanySlugSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/share': typeof ShareRouteWithChildren
  '/$companySlug': typeof AuthedNoSidebarCompanySlugRouteWithChildren
  '/discover': typeof AuthedDiscoverRoute
  '/profile': typeof AuthedProfileRoute
  '/auth/accounts': typeof AuthAccountsRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/signup': typeof AuthSignupRoute
  '/onboarding/company-setup': typeof OnboardingCompanySetupRoute
  '/auth/': typeof AuthIndexRoute
  '/$companySlug/admin': typeof AuthedCompanySlugAdminRouteWithChildren
  '/$companySlug/intelligence': typeof AuthedCompanySlugIntelligenceRoute
  '/$companySlug/tasks': typeof AuthedCompanySlugTasksRoute
  '/share/tender/$token': typeof ShareTenderTokenRoute
  '/$companySlug/': typeof AuthedCompanySlugIndexRoute
  '/$companySlug/admin/access-credits': typeof AuthedCompanySlugAdminAccessCreditsRoute
  '/$companySlug/admin/category-images': typeof AuthedCompanySlugAdminCategoryImagesRoute
  '/$companySlug/admin/clients': typeof AuthedCompanySlugAdminClientsRouteWithChildren
  '/$companySlug/admin/feature-flags': typeof AuthedCompanySlugAdminFeatureFlagsRoute
  '/$companySlug/admin/users': typeof AuthedCompanySlugAdminUsersRouteWithChildren
  '/$companySlug/upgrade': typeof AuthedNoSidebarCompanySlugUpgradeRoute
  '/$companySlug/admin/': typeof AuthedCompanySlugAdminIndexRoute
  '/$companySlug/caselaw/': typeof AuthedCompanySlugCaselawIndexRoute
  '/$companySlug/horizon/': typeof AuthedCompanySlugHorizonIndexRoute
  '/$companySlug/organisations/': typeof AuthedCompanySlugOrganisationsIndexRoute
  '/$companySlug/organizations/': typeof AuthedCompanySlugOrganizationsIndexRoute
  '/$companySlug/procurement-calendar/': typeof AuthedCompanySlugProcurementCalendarIndexRoute
  '/$companySlug/tenders/': typeof AuthedCompanySlugTendersIndexRoute
  '/$companySlug/workflows/': typeof AuthedCompanySlugWorkflowsIndexRoute
  '/$companySlug/settings/api': typeof AuthedCompanySlugSettingsSettingsApiRoute
  '/$companySlug/settings/company': typeof AuthedCompanySlugSettingsSettingsCompanyRoute
  '/$companySlug/settings/integrations': typeof AuthedCompanySlugSettingsSettingsIntegrationsRoute
  '/$companySlug/settings/labels': typeof AuthedCompanySlugSettingsSettingsLabelsRoute
  '/$companySlug/settings/mcp': typeof AuthedCompanySlugSettingsSettingsMcpRoute
  '/$companySlug/settings/notifications': typeof AuthedCompanySlugSettingsSettingsNotificationsRoute
  '/$companySlug/settings/profile': typeof AuthedCompanySlugSettingsSettingsProfileRoute
  '/$companySlug/settings/rejection-reason': typeof AuthedCompanySlugSettingsSettingsRejectionReasonRoute
  '/$companySlug/settings/teams': typeof AuthedCompanySlugSettingsSettingsTeamsRoute
  '/$companySlug/admin/clients/$clientId': typeof AuthedCompanySlugAdminClientsClientIdRoute
  '/$companySlug/admin/procurement-calendar/new': typeof AuthedCompanySlugAdminProcurementCalendarNewRoute
  '/$companySlug/subscribe/callback': typeof AuthedNoSidebarCompanySlugSubscribeCallbackRoute
  '/$companySlug/subscribe/failed': typeof AuthedNoSidebarCompanySlugSubscribeFailedRoute
  '/$companySlug/subscribe/overdue': typeof AuthedNoSidebarCompanySlugSubscribeOverdueRoute
  '/$companySlug/subscribe/success': typeof AuthedNoSidebarCompanySlugSubscribeSuccessRoute
  '/$companySlug/admin/clients/': typeof AuthedCompanySlugAdminClientsIndexRoute
  '/$companySlug/admin/users/': typeof AuthedCompanySlugAdminUsersIndexRoute
  '/$companySlug/caselaw/$caselawId/': typeof AuthedCompanySlugCaselawCaselawIdIndexRoute
  '/$companySlug/horizon/$itemId/': typeof AuthedCompanySlugHorizonItemIdIndexRoute
  '/$companySlug/organisations/$organizationId/': typeof AuthedCompanySlugOrganisationsOrganizationIdIndexRoute
  '/$companySlug/organizations/$organizationId/': typeof AuthedCompanySlugOrganizationsOrganizationIdIndexRoute
  '/$companySlug/tenders/$tenderId/': typeof AuthedCompanySlugTendersTenderIdIndexRoute
  '/$companySlug/subscribe/': typeof AuthedNoSidebarCompanySlugSubscribeIndexRoute
  '/$companySlug/settings/subscription/credit-history': typeof AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute
  '/$companySlug/admin/sourcing/websites/$websiteId': typeof AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute
  '/$companySlug/settings/subscription/': typeof AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute
  '/$companySlug/settings/users/': typeof AuthedCompanySlugSettingsSettingsUsersIndexRoute
  '/$companySlug/settings/workflows/': typeof AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute
  '/$companySlug/admin/sourcing/entries/': typeof AuthedCompanySlugAdminSourcingEntriesIndexRoute
  '/$companySlug/admin/sourcing/overview/': typeof AuthedCompanySlugAdminSourcingOverviewIndexRoute
  '/$companySlug/admin/sourcing/review/': typeof AuthedCompanySlugAdminSourcingReviewIndexRoute
  '/$companySlug/admin/sourcing/websites/': typeof AuthedCompanySlugAdminSourcingWebsitesIndexRoute
  '/$companySlug/settings/users/$userId/': typeof AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute
  '/$companySlug/settings/workflows/$workflowId/': typeof AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute
}
export interface FileRoutesByTo {
  '/share': typeof ShareRouteWithChildren
  '/': typeof AuthedIndexRoute
  '/discover': typeof AuthedDiscoverRoute
  '/profile': typeof AuthedProfileRoute
  '/auth/accounts': typeof AuthAccountsRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/signup': typeof AuthSignupRoute
  '/onboarding/company-setup': typeof OnboardingCompanySetupRoute
  '/auth': typeof AuthIndexRoute
  '/$companySlug': typeof AuthedCompanySlugIndexRoute
  '/$companySlug/intelligence': typeof AuthedCompanySlugIntelligenceRoute
  '/$companySlug/tasks': typeof AuthedCompanySlugTasksRoute
  '/share/tender/$token': typeof ShareTenderTokenRoute
  '/$companySlug/admin/access-credits': typeof AuthedCompanySlugAdminAccessCreditsRoute
  '/$companySlug/admin/category-images': typeof AuthedCompanySlugAdminCategoryImagesRoute
  '/$companySlug/admin/feature-flags': typeof AuthedCompanySlugAdminFeatureFlagsRoute
  '/$companySlug/upgrade': typeof AuthedNoSidebarCompanySlugUpgradeRoute
  '/$companySlug/admin': typeof AuthedCompanySlugAdminIndexRoute
  '/$companySlug/caselaw': typeof AuthedCompanySlugCaselawIndexRoute
  '/$companySlug/horizon': typeof AuthedCompanySlugHorizonIndexRoute
  '/$companySlug/organisations': typeof AuthedCompanySlugOrganisationsIndexRoute
  '/$companySlug/organizations': typeof AuthedCompanySlugOrganizationsIndexRoute
  '/$companySlug/procurement-calendar': typeof AuthedCompanySlugProcurementCalendarIndexRoute
  '/$companySlug/tenders': typeof AuthedCompanySlugTendersIndexRoute
  '/$companySlug/workflows': typeof AuthedCompanySlugWorkflowsIndexRoute
  '/$companySlug/settings/api': typeof AuthedCompanySlugSettingsSettingsApiRoute
  '/$companySlug/settings/company': typeof AuthedCompanySlugSettingsSettingsCompanyRoute
  '/$companySlug/settings/integrations': typeof AuthedCompanySlugSettingsSettingsIntegrationsRoute
  '/$companySlug/settings/labels': typeof AuthedCompanySlugSettingsSettingsLabelsRoute
  '/$companySlug/settings/mcp': typeof AuthedCompanySlugSettingsSettingsMcpRoute
  '/$companySlug/settings/notifications': typeof AuthedCompanySlugSettingsSettingsNotificationsRoute
  '/$companySlug/settings/profile': typeof AuthedCompanySlugSettingsSettingsProfileRoute
  '/$companySlug/settings/rejection-reason': typeof AuthedCompanySlugSettingsSettingsRejectionReasonRoute
  '/$companySlug/settings/teams': typeof AuthedCompanySlugSettingsSettingsTeamsRoute
  '/$companySlug/admin/clients/$clientId': typeof AuthedCompanySlugAdminClientsClientIdRoute
  '/$companySlug/admin/procurement-calendar/new': typeof AuthedCompanySlugAdminProcurementCalendarNewRoute
  '/$companySlug/subscribe/callback': typeof AuthedNoSidebarCompanySlugSubscribeCallbackRoute
  '/$companySlug/subscribe/failed': typeof AuthedNoSidebarCompanySlugSubscribeFailedRoute
  '/$companySlug/subscribe/overdue': typeof AuthedNoSidebarCompanySlugSubscribeOverdueRoute
  '/$companySlug/subscribe/success': typeof AuthedNoSidebarCompanySlugSubscribeSuccessRoute
  '/$companySlug/admin/clients': typeof AuthedCompanySlugAdminClientsIndexRoute
  '/$companySlug/admin/users': typeof AuthedCompanySlugAdminUsersIndexRoute
  '/$companySlug/caselaw/$caselawId': typeof AuthedCompanySlugCaselawCaselawIdIndexRoute
  '/$companySlug/horizon/$itemId': typeof AuthedCompanySlugHorizonItemIdIndexRoute
  '/$companySlug/organisations/$organizationId': typeof AuthedCompanySlugOrganisationsOrganizationIdIndexRoute
  '/$companySlug/organizations/$organizationId': typeof AuthedCompanySlugOrganizationsOrganizationIdIndexRoute
  '/$companySlug/tenders/$tenderId': typeof AuthedCompanySlugTendersTenderIdIndexRoute
  '/$companySlug/subscribe': typeof AuthedNoSidebarCompanySlugSubscribeIndexRoute
  '/$companySlug/settings/subscription/credit-history': typeof AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute
  '/$companySlug/admin/sourcing/websites/$websiteId': typeof AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute
  '/$companySlug/settings/subscription': typeof AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute
  '/$companySlug/settings/users': typeof AuthedCompanySlugSettingsSettingsUsersIndexRoute
  '/$companySlug/settings/workflows': typeof AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute
  '/$companySlug/admin/sourcing/entries': typeof AuthedCompanySlugAdminSourcingEntriesIndexRoute
  '/$companySlug/admin/sourcing/overview': typeof AuthedCompanySlugAdminSourcingOverviewIndexRoute
  '/$companySlug/admin/sourcing/review': typeof AuthedCompanySlugAdminSourcingReviewIndexRoute
  '/$companySlug/admin/sourcing/websites': typeof AuthedCompanySlugAdminSourcingWebsitesIndexRoute
  '/$companySlug/settings/users/$userId': typeof AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute
  '/$companySlug/settings/workflows/$workflowId': typeof AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/share': typeof ShareRouteWithChildren
  '/_authed/$companySlug': typeof AuthedCompanySlugRouteWithChildren
  '/_authed/_noSidebar': typeof AuthedNoSidebarRouteWithChildren
  '/_authed/discover': typeof AuthedDiscoverRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/auth/accounts': typeof AuthAccountsRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/signup': typeof AuthSignupRoute
  '/onboarding/company-setup': typeof OnboardingCompanySetupRoute
  '/_authed/': typeof AuthedIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_authed/$companySlug/_settings': typeof AuthedCompanySlugSettingsRouteWithChildren
  '/_authed/$companySlug/admin': typeof AuthedCompanySlugAdminRouteWithChildren
  '/_authed/$companySlug/intelligence': typeof AuthedCompanySlugIntelligenceRoute
  '/_authed/$companySlug/tasks': typeof AuthedCompanySlugTasksRoute
  '/_authed/_noSidebar/$companySlug': typeof AuthedNoSidebarCompanySlugRouteWithChildren
  '/share/tender/$token': typeof ShareTenderTokenRoute
  '/_authed/$companySlug/': typeof AuthedCompanySlugIndexRoute
  '/_authed/$companySlug/admin/access-credits': typeof AuthedCompanySlugAdminAccessCreditsRoute
  '/_authed/$companySlug/admin/category-images': typeof AuthedCompanySlugAdminCategoryImagesRoute
  '/_authed/$companySlug/admin/clients': typeof AuthedCompanySlugAdminClientsRouteWithChildren
  '/_authed/$companySlug/admin/feature-flags': typeof AuthedCompanySlugAdminFeatureFlagsRoute
  '/_authed/$companySlug/admin/users': typeof AuthedCompanySlugAdminUsersRouteWithChildren
  '/_authed/_noSidebar/$companySlug/upgrade': typeof AuthedNoSidebarCompanySlugUpgradeRoute
  '/_authed/$companySlug/admin/': typeof AuthedCompanySlugAdminIndexRoute
  '/_authed/$companySlug/caselaw/': typeof AuthedCompanySlugCaselawIndexRoute
  '/_authed/$companySlug/horizon/': typeof AuthedCompanySlugHorizonIndexRoute
  '/_authed/$companySlug/organisations/': typeof AuthedCompanySlugOrganisationsIndexRoute
  '/_authed/$companySlug/organizations/': typeof AuthedCompanySlugOrganizationsIndexRoute
  '/_authed/$companySlug/procurement-calendar/': typeof AuthedCompanySlugProcurementCalendarIndexRoute
  '/_authed/$companySlug/tenders/': typeof AuthedCompanySlugTendersIndexRoute
  '/_authed/$companySlug/workflows/': typeof AuthedCompanySlugWorkflowsIndexRoute
  '/_authed/$companySlug/_settings/settings/api': typeof AuthedCompanySlugSettingsSettingsApiRoute
  '/_authed/$companySlug/_settings/settings/company': typeof AuthedCompanySlugSettingsSettingsCompanyRoute
  '/_authed/$companySlug/_settings/settings/integrations': typeof AuthedCompanySlugSettingsSettingsIntegrationsRoute
  '/_authed/$companySlug/_settings/settings/labels': typeof AuthedCompanySlugSettingsSettingsLabelsRoute
  '/_authed/$companySlug/_settings/settings/mcp': typeof AuthedCompanySlugSettingsSettingsMcpRoute
  '/_authed/$companySlug/_settings/settings/notifications': typeof AuthedCompanySlugSettingsSettingsNotificationsRoute
  '/_authed/$companySlug/_settings/settings/profile': typeof AuthedCompanySlugSettingsSettingsProfileRoute
  '/_authed/$companySlug/_settings/settings/rejection-reason': typeof AuthedCompanySlugSettingsSettingsRejectionReasonRoute
  '/_authed/$companySlug/_settings/settings/teams': typeof AuthedCompanySlugSettingsSettingsTeamsRoute
  '/_authed/$companySlug/admin/clients/$clientId': typeof AuthedCompanySlugAdminClientsClientIdRoute
  '/_authed/$companySlug/admin/procurement-calendar/new': typeof AuthedCompanySlugAdminProcurementCalendarNewRoute
  '/_authed/_noSidebar/$companySlug/subscribe/callback': typeof AuthedNoSidebarCompanySlugSubscribeCallbackRoute
  '/_authed/_noSidebar/$companySlug/subscribe/failed': typeof AuthedNoSidebarCompanySlugSubscribeFailedRoute
  '/_authed/_noSidebar/$companySlug/subscribe/overdue': typeof AuthedNoSidebarCompanySlugSubscribeOverdueRoute
  '/_authed/_noSidebar/$companySlug/subscribe/success': typeof AuthedNoSidebarCompanySlugSubscribeSuccessRoute
  '/_authed/$companySlug/admin/clients/': typeof AuthedCompanySlugAdminClientsIndexRoute
  '/_authed/$companySlug/admin/users/': typeof AuthedCompanySlugAdminUsersIndexRoute
  '/_authed/$companySlug/caselaw/$caselawId/': typeof AuthedCompanySlugCaselawCaselawIdIndexRoute
  '/_authed/$companySlug/horizon/$itemId/': typeof AuthedCompanySlugHorizonItemIdIndexRoute
  '/_authed/$companySlug/organisations/$organizationId/': typeof AuthedCompanySlugOrganisationsOrganizationIdIndexRoute
  '/_authed/$companySlug/organizations/$organizationId/': typeof AuthedCompanySlugOrganizationsOrganizationIdIndexRoute
  '/_authed/$companySlug/tenders/$tenderId/': typeof AuthedCompanySlugTendersTenderIdIndexRoute
  '/_authed/_noSidebar/$companySlug/subscribe/': typeof AuthedNoSidebarCompanySlugSubscribeIndexRoute
  '/_authed/$companySlug/_settings/settings/subscription/credit-history': typeof AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute
  '/_authed/$companySlug/admin/sourcing/websites/$websiteId': typeof AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute
  '/_authed/$companySlug/_settings/settings/subscription/': typeof AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute
  '/_authed/$companySlug/_settings/settings/users/': typeof AuthedCompanySlugSettingsSettingsUsersIndexRoute
  '/_authed/$companySlug/_settings/settings/workflows/': typeof AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute
  '/_authed/$companySlug/admin/sourcing/entries/': typeof AuthedCompanySlugAdminSourcingEntriesIndexRoute
  '/_authed/$companySlug/admin/sourcing/overview/': typeof AuthedCompanySlugAdminSourcingOverviewIndexRoute
  '/_authed/$companySlug/admin/sourcing/review/': typeof AuthedCompanySlugAdminSourcingReviewIndexRoute
  '/_authed/$companySlug/admin/sourcing/websites/': typeof AuthedCompanySlugAdminSourcingWebsitesIndexRoute
  '/_authed/$companySlug/_settings/settings/users/$userId/': typeof AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute
  '/_authed/$companySlug/_settings/settings/workflows/$workflowId/': typeof AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/share'
    | '/$companySlug'
    | '/discover'
    | '/profile'
    | '/auth/accounts'
    | '/auth/join'
    | '/auth/signup'
    | '/onboarding/company-setup'
    | '/auth/'
    | '/$companySlug/admin'
    | '/$companySlug/intelligence'
    | '/$companySlug/tasks'
    | '/share/tender/$token'
    | '/$companySlug/'
    | '/$companySlug/admin/access-credits'
    | '/$companySlug/admin/category-images'
    | '/$companySlug/admin/clients'
    | '/$companySlug/admin/feature-flags'
    | '/$companySlug/admin/users'
    | '/$companySlug/upgrade'
    | '/$companySlug/admin/'
    | '/$companySlug/caselaw/'
    | '/$companySlug/horizon/'
    | '/$companySlug/organisations/'
    | '/$companySlug/organizations/'
    | '/$companySlug/procurement-calendar/'
    | '/$companySlug/tenders/'
    | '/$companySlug/workflows/'
    | '/$companySlug/settings/api'
    | '/$companySlug/settings/company'
    | '/$companySlug/settings/integrations'
    | '/$companySlug/settings/labels'
    | '/$companySlug/settings/mcp'
    | '/$companySlug/settings/notifications'
    | '/$companySlug/settings/profile'
    | '/$companySlug/settings/rejection-reason'
    | '/$companySlug/settings/teams'
    | '/$companySlug/admin/clients/$clientId'
    | '/$companySlug/admin/procurement-calendar/new'
    | '/$companySlug/subscribe/callback'
    | '/$companySlug/subscribe/failed'
    | '/$companySlug/subscribe/overdue'
    | '/$companySlug/subscribe/success'
    | '/$companySlug/admin/clients/'
    | '/$companySlug/admin/users/'
    | '/$companySlug/caselaw/$caselawId/'
    | '/$companySlug/horizon/$itemId/'
    | '/$companySlug/organisations/$organizationId/'
    | '/$companySlug/organizations/$organizationId/'
    | '/$companySlug/tenders/$tenderId/'
    | '/$companySlug/subscribe/'
    | '/$companySlug/settings/subscription/credit-history'
    | '/$companySlug/admin/sourcing/websites/$websiteId'
    | '/$companySlug/settings/subscription/'
    | '/$companySlug/settings/users/'
    | '/$companySlug/settings/workflows/'
    | '/$companySlug/admin/sourcing/entries/'
    | '/$companySlug/admin/sourcing/overview/'
    | '/$companySlug/admin/sourcing/review/'
    | '/$companySlug/admin/sourcing/websites/'
    | '/$companySlug/settings/users/$userId/'
    | '/$companySlug/settings/workflows/$workflowId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/share'
    | '/'
    | '/discover'
    | '/profile'
    | '/auth/accounts'
    | '/auth/join'
    | '/auth/signup'
    | '/onboarding/company-setup'
    | '/auth'
    | '/$companySlug'
    | '/$companySlug/intelligence'
    | '/$companySlug/tasks'
    | '/share/tender/$token'
    | '/$companySlug/admin/access-credits'
    | '/$companySlug/admin/category-images'
    | '/$companySlug/admin/feature-flags'
    | '/$companySlug/upgrade'
    | '/$companySlug/admin'
    | '/$companySlug/caselaw'
    | '/$companySlug/horizon'
    | '/$companySlug/organisations'
    | '/$companySlug/organizations'
    | '/$companySlug/procurement-calendar'
    | '/$companySlug/tenders'
    | '/$companySlug/workflows'
    | '/$companySlug/settings/api'
    | '/$companySlug/settings/company'
    | '/$companySlug/settings/integrations'
    | '/$companySlug/settings/labels'
    | '/$companySlug/settings/mcp'
    | '/$companySlug/settings/notifications'
    | '/$companySlug/settings/profile'
    | '/$companySlug/settings/rejection-reason'
    | '/$companySlug/settings/teams'
    | '/$companySlug/admin/clients/$clientId'
    | '/$companySlug/admin/procurement-calendar/new'
    | '/$companySlug/subscribe/callback'
    | '/$companySlug/subscribe/failed'
    | '/$companySlug/subscribe/overdue'
    | '/$companySlug/subscribe/success'
    | '/$companySlug/admin/clients'
    | '/$companySlug/admin/users'
    | '/$companySlug/caselaw/$caselawId'
    | '/$companySlug/horizon/$itemId'
    | '/$companySlug/organisations/$organizationId'
    | '/$companySlug/organizations/$organizationId'
    | '/$companySlug/tenders/$tenderId'
    | '/$companySlug/subscribe'
    | '/$companySlug/settings/subscription/credit-history'
    | '/$companySlug/admin/sourcing/websites/$websiteId'
    | '/$companySlug/settings/subscription'
    | '/$companySlug/settings/users'
    | '/$companySlug/settings/workflows'
    | '/$companySlug/admin/sourcing/entries'
    | '/$companySlug/admin/sourcing/overview'
    | '/$companySlug/admin/sourcing/review'
    | '/$companySlug/admin/sourcing/websites'
    | '/$companySlug/settings/users/$userId'
    | '/$companySlug/settings/workflows/$workflowId'
  id:
    | '__root__'
    | '/_authed'
    | '/auth'
    | '/share'
    | '/_authed/$companySlug'
    | '/_authed/_noSidebar'
    | '/_authed/discover'
    | '/_authed/profile'
    | '/auth/accounts'
    | '/auth/join'
    | '/auth/signup'
    | '/onboarding/company-setup'
    | '/_authed/'
    | '/auth/'
    | '/_authed/$companySlug/_settings'
    | '/_authed/$companySlug/admin'
    | '/_authed/$companySlug/intelligence'
    | '/_authed/$companySlug/tasks'
    | '/_authed/_noSidebar/$companySlug'
    | '/share/tender/$token'
    | '/_authed/$companySlug/'
    | '/_authed/$companySlug/admin/access-credits'
    | '/_authed/$companySlug/admin/category-images'
    | '/_authed/$companySlug/admin/clients'
    | '/_authed/$companySlug/admin/feature-flags'
    | '/_authed/$companySlug/admin/users'
    | '/_authed/_noSidebar/$companySlug/upgrade'
    | '/_authed/$companySlug/admin/'
    | '/_authed/$companySlug/caselaw/'
    | '/_authed/$companySlug/horizon/'
    | '/_authed/$companySlug/organisations/'
    | '/_authed/$companySlug/organizations/'
    | '/_authed/$companySlug/procurement-calendar/'
    | '/_authed/$companySlug/tenders/'
    | '/_authed/$companySlug/workflows/'
    | '/_authed/$companySlug/_settings/settings/api'
    | '/_authed/$companySlug/_settings/settings/company'
    | '/_authed/$companySlug/_settings/settings/integrations'
    | '/_authed/$companySlug/_settings/settings/labels'
    | '/_authed/$companySlug/_settings/settings/mcp'
    | '/_authed/$companySlug/_settings/settings/notifications'
    | '/_authed/$companySlug/_settings/settings/profile'
    | '/_authed/$companySlug/_settings/settings/rejection-reason'
    | '/_authed/$companySlug/_settings/settings/teams'
    | '/_authed/$companySlug/admin/clients/$clientId'
    | '/_authed/$companySlug/admin/procurement-calendar/new'
    | '/_authed/_noSidebar/$companySlug/subscribe/callback'
    | '/_authed/_noSidebar/$companySlug/subscribe/failed'
    | '/_authed/_noSidebar/$companySlug/subscribe/overdue'
    | '/_authed/_noSidebar/$companySlug/subscribe/success'
    | '/_authed/$companySlug/admin/clients/'
    | '/_authed/$companySlug/admin/users/'
    | '/_authed/$companySlug/caselaw/$caselawId/'
    | '/_authed/$companySlug/horizon/$itemId/'
    | '/_authed/$companySlug/organisations/$organizationId/'
    | '/_authed/$companySlug/organizations/$organizationId/'
    | '/_authed/$companySlug/tenders/$tenderId/'
    | '/_authed/_noSidebar/$companySlug/subscribe/'
    | '/_authed/$companySlug/_settings/settings/subscription/credit-history'
    | '/_authed/$companySlug/admin/sourcing/websites/$websiteId'
    | '/_authed/$companySlug/_settings/settings/subscription/'
    | '/_authed/$companySlug/_settings/settings/users/'
    | '/_authed/$companySlug/_settings/settings/workflows/'
    | '/_authed/$companySlug/admin/sourcing/entries/'
    | '/_authed/$companySlug/admin/sourcing/overview/'
    | '/_authed/$companySlug/admin/sourcing/review/'
    | '/_authed/$companySlug/admin/sourcing/websites/'
    | '/_authed/$companySlug/_settings/settings/users/$userId/'
    | '/_authed/$companySlug/_settings/settings/workflows/$workflowId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ShareRoute: typeof ShareRouteWithChildren
  OnboardingCompanySetupRoute: typeof OnboardingCompanySetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share': {
      id: '/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$companySlug': {
      id: '/_authed/$companySlug'
      path: '/$companySlug'
      fullPath: '/$companySlug'
      preLoaderRoute: typeof AuthedCompanySlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_noSidebar': {
      id: '/_authed/_noSidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedNoSidebarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/discover': {
      id: '/_authed/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof AuthedDiscoverRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/accounts': {
      id: '/auth/accounts'
      path: '/accounts'
      fullPath: '/auth/accounts'
      preLoaderRoute: typeof AuthAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/join': {
      id: '/auth/join'
      path: '/join'
      fullPath: '/auth/join'
      preLoaderRoute: typeof AuthJoinRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/onboarding/company-setup': {
      id: '/onboarding/company-setup'
      path: '/onboarding/company-setup'
      fullPath: '/onboarding/company-setup'
      preLoaderRoute: typeof OnboardingCompanySetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/$companySlug/': {
      id: '/_authed/$companySlug/'
      path: '/'
      fullPath: '/$companySlug/'
      preLoaderRoute: typeof AuthedCompanySlugIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/_settings': {
      id: '/_authed/$companySlug/_settings'
      path: ''
      fullPath: '/$companySlug'
      preLoaderRoute: typeof AuthedCompanySlugSettingsRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/admin': {
      id: '/_authed/$companySlug/admin'
      path: '/admin'
      fullPath: '/$companySlug/admin'
      preLoaderRoute: typeof AuthedCompanySlugAdminRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/intelligence': {
      id: '/_authed/$companySlug/intelligence'
      path: '/intelligence'
      fullPath: '/$companySlug/intelligence'
      preLoaderRoute: typeof AuthedCompanySlugIntelligenceRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/tasks': {
      id: '/_authed/$companySlug/tasks'
      path: '/tasks'
      fullPath: '/$companySlug/tasks'
      preLoaderRoute: typeof AuthedCompanySlugTasksRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug': {
      id: '/_authed/_noSidebar/$companySlug'
      path: '/$companySlug'
      fullPath: '/$companySlug'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugRouteImport
      parentRoute: typeof AuthedNoSidebarRoute
    }
    '/share/tender/$token': {
      id: '/share/tender/$token'
      path: '/tender/$token'
      fullPath: '/share/tender/$token'
      preLoaderRoute: typeof ShareTenderTokenRouteImport
      parentRoute: typeof ShareRoute
    }
    '/_authed/$companySlug/admin/': {
      id: '/_authed/$companySlug/admin/'
      path: '/'
      fullPath: '/$companySlug/admin/'
      preLoaderRoute: typeof AuthedCompanySlugAdminIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/access-credits': {
      id: '/_authed/$companySlug/admin/access-credits'
      path: '/access-credits'
      fullPath: '/$companySlug/admin/access-credits'
      preLoaderRoute: typeof AuthedCompanySlugAdminAccessCreditsRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/category-images': {
      id: '/_authed/$companySlug/admin/category-images'
      path: '/category-images'
      fullPath: '/$companySlug/admin/category-images'
      preLoaderRoute: typeof AuthedCompanySlugAdminCategoryImagesRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/clients': {
      id: '/_authed/$companySlug/admin/clients'
      path: '/clients'
      fullPath: '/$companySlug/admin/clients'
      preLoaderRoute: typeof AuthedCompanySlugAdminClientsRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/feature-flags': {
      id: '/_authed/$companySlug/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/$companySlug/admin/feature-flags'
      preLoaderRoute: typeof AuthedCompanySlugAdminFeatureFlagsRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/users': {
      id: '/_authed/$companySlug/admin/users'
      path: '/users'
      fullPath: '/$companySlug/admin/users'
      preLoaderRoute: typeof AuthedCompanySlugAdminUsersRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/caselaw/': {
      id: '/_authed/$companySlug/caselaw/'
      path: '/caselaw'
      fullPath: '/$companySlug/caselaw/'
      preLoaderRoute: typeof AuthedCompanySlugCaselawIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/horizon/': {
      id: '/_authed/$companySlug/horizon/'
      path: '/horizon'
      fullPath: '/$companySlug/horizon/'
      preLoaderRoute: typeof AuthedCompanySlugHorizonIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/organisations/': {
      id: '/_authed/$companySlug/organisations/'
      path: '/organisations'
      fullPath: '/$companySlug/organisations/'
      preLoaderRoute: typeof AuthedCompanySlugOrganisationsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/organizations/': {
      id: '/_authed/$companySlug/organizations/'
      path: '/organizations'
      fullPath: '/$companySlug/organizations/'
      preLoaderRoute: typeof AuthedCompanySlugOrganizationsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/procurement-calendar/': {
      id: '/_authed/$companySlug/procurement-calendar/'
      path: '/procurement-calendar'
      fullPath: '/$companySlug/procurement-calendar/'
      preLoaderRoute: typeof AuthedCompanySlugProcurementCalendarIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/tenders/': {
      id: '/_authed/$companySlug/tenders/'
      path: '/tenders'
      fullPath: '/$companySlug/tenders/'
      preLoaderRoute: typeof AuthedCompanySlugTendersIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/workflows/': {
      id: '/_authed/$companySlug/workflows/'
      path: '/workflows'
      fullPath: '/$companySlug/workflows/'
      preLoaderRoute: typeof AuthedCompanySlugWorkflowsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/upgrade': {
      id: '/_authed/_noSidebar/$companySlug/upgrade'
      path: '/upgrade'
      fullPath: '/$companySlug/upgrade'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugUpgradeRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/$companySlug/_settings/settings/api': {
      id: '/_authed/$companySlug/_settings/settings/api'
      path: '/settings/api'
      fullPath: '/$companySlug/settings/api'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsApiRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/company': {
      id: '/_authed/$companySlug/_settings/settings/company'
      path: '/settings/company'
      fullPath: '/$companySlug/settings/company'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsCompanyRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/integrations': {
      id: '/_authed/$companySlug/_settings/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/$companySlug/settings/integrations'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsIntegrationsRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/labels': {
      id: '/_authed/$companySlug/_settings/settings/labels'
      path: '/settings/labels'
      fullPath: '/$companySlug/settings/labels'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsLabelsRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/mcp': {
      id: '/_authed/$companySlug/_settings/settings/mcp'
      path: '/settings/mcp'
      fullPath: '/$companySlug/settings/mcp'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsMcpRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/notifications': {
      id: '/_authed/$companySlug/_settings/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/$companySlug/settings/notifications'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsNotificationsRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/profile': {
      id: '/_authed/$companySlug/_settings/settings/profile'
      path: '/settings/profile'
      fullPath: '/$companySlug/settings/profile'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsProfileRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/rejection-reason': {
      id: '/_authed/$companySlug/_settings/settings/rejection-reason'
      path: '/settings/rejection-reason'
      fullPath: '/$companySlug/settings/rejection-reason'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsRejectionReasonRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/teams': {
      id: '/_authed/$companySlug/_settings/settings/teams'
      path: '/settings/teams'
      fullPath: '/$companySlug/settings/teams'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsTeamsRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/admin/clients/': {
      id: '/_authed/$companySlug/admin/clients/'
      path: '/'
      fullPath: '/$companySlug/admin/clients/'
      preLoaderRoute: typeof AuthedCompanySlugAdminClientsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminClientsRoute
    }
    '/_authed/$companySlug/admin/clients/$clientId': {
      id: '/_authed/$companySlug/admin/clients/$clientId'
      path: '/$clientId'
      fullPath: '/$companySlug/admin/clients/$clientId'
      preLoaderRoute: typeof AuthedCompanySlugAdminClientsClientIdRouteImport
      parentRoute: typeof AuthedCompanySlugAdminClientsRoute
    }
    '/_authed/$companySlug/admin/procurement-calendar/new': {
      id: '/_authed/$companySlug/admin/procurement-calendar/new'
      path: '/procurement-calendar/new'
      fullPath: '/$companySlug/admin/procurement-calendar/new'
      preLoaderRoute: typeof AuthedCompanySlugAdminProcurementCalendarNewRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/users/': {
      id: '/_authed/$companySlug/admin/users/'
      path: '/'
      fullPath: '/$companySlug/admin/users/'
      preLoaderRoute: typeof AuthedCompanySlugAdminUsersIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminUsersRoute
    }
    '/_authed/$companySlug/caselaw/$caselawId/': {
      id: '/_authed/$companySlug/caselaw/$caselawId/'
      path: '/caselaw/$caselawId'
      fullPath: '/$companySlug/caselaw/$caselawId/'
      preLoaderRoute: typeof AuthedCompanySlugCaselawCaselawIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/horizon/$itemId/': {
      id: '/_authed/$companySlug/horizon/$itemId/'
      path: '/horizon/$itemId'
      fullPath: '/$companySlug/horizon/$itemId/'
      preLoaderRoute: typeof AuthedCompanySlugHorizonItemIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/organisations/$organizationId/': {
      id: '/_authed/$companySlug/organisations/$organizationId/'
      path: '/organisations/$organizationId'
      fullPath: '/$companySlug/organisations/$organizationId/'
      preLoaderRoute: typeof AuthedCompanySlugOrganisationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/organizations/$organizationId/': {
      id: '/_authed/$companySlug/organizations/$organizationId/'
      path: '/organizations/$organizationId'
      fullPath: '/$companySlug/organizations/$organizationId/'
      preLoaderRoute: typeof AuthedCompanySlugOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/tenders/$tenderId/': {
      id: '/_authed/$companySlug/tenders/$tenderId/'
      path: '/tenders/$tenderId'
      fullPath: '/$companySlug/tenders/$tenderId/'
      preLoaderRoute: typeof AuthedCompanySlugTendersTenderIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/subscribe/': {
      id: '/_authed/_noSidebar/$companySlug/subscribe/'
      path: '/subscribe'
      fullPath: '/$companySlug/subscribe/'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugSubscribeIndexRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/subscribe/callback': {
      id: '/_authed/_noSidebar/$companySlug/subscribe/callback'
      path: '/subscribe/callback'
      fullPath: '/$companySlug/subscribe/callback'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugSubscribeCallbackRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/subscribe/failed': {
      id: '/_authed/_noSidebar/$companySlug/subscribe/failed'
      path: '/subscribe/failed'
      fullPath: '/$companySlug/subscribe/failed'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugSubscribeFailedRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/subscribe/overdue': {
      id: '/_authed/_noSidebar/$companySlug/subscribe/overdue'
      path: '/subscribe/overdue'
      fullPath: '/$companySlug/subscribe/overdue'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugSubscribeOverdueRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/_noSidebar/$companySlug/subscribe/success': {
      id: '/_authed/_noSidebar/$companySlug/subscribe/success'
      path: '/subscribe/success'
      fullPath: '/$companySlug/subscribe/success'
      preLoaderRoute: typeof AuthedNoSidebarCompanySlugSubscribeSuccessRouteImport
      parentRoute: typeof AuthedNoSidebarCompanySlugRoute
    }
    '/_authed/$companySlug/_settings/settings/subscription/': {
      id: '/_authed/$companySlug/_settings/settings/subscription/'
      path: '/settings/subscription'
      fullPath: '/$companySlug/settings/subscription/'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsSubscriptionIndexRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/subscription/credit-history': {
      id: '/_authed/$companySlug/_settings/settings/subscription/credit-history'
      path: '/settings/subscription/credit-history'
      fullPath: '/$companySlug/settings/subscription/credit-history'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/users/': {
      id: '/_authed/$companySlug/_settings/settings/users/'
      path: '/settings/users'
      fullPath: '/$companySlug/settings/users/'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsUsersIndexRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/workflows/': {
      id: '/_authed/$companySlug/_settings/settings/workflows/'
      path: '/settings/workflows'
      fullPath: '/$companySlug/settings/workflows/'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsWorkflowsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/admin/sourcing/entries/': {
      id: '/_authed/$companySlug/admin/sourcing/entries/'
      path: '/sourcing/entries'
      fullPath: '/$companySlug/admin/sourcing/entries/'
      preLoaderRoute: typeof AuthedCompanySlugAdminSourcingEntriesIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/sourcing/overview/': {
      id: '/_authed/$companySlug/admin/sourcing/overview/'
      path: '/sourcing/overview'
      fullPath: '/$companySlug/admin/sourcing/overview/'
      preLoaderRoute: typeof AuthedCompanySlugAdminSourcingOverviewIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/sourcing/review/': {
      id: '/_authed/$companySlug/admin/sourcing/review/'
      path: '/sourcing/review'
      fullPath: '/$companySlug/admin/sourcing/review/'
      preLoaderRoute: typeof AuthedCompanySlugAdminSourcingReviewIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/sourcing/websites/': {
      id: '/_authed/$companySlug/admin/sourcing/websites/'
      path: '/sourcing/websites'
      fullPath: '/$companySlug/admin/sourcing/websites/'
      preLoaderRoute: typeof AuthedCompanySlugAdminSourcingWebsitesIndexRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/admin/sourcing/websites/$websiteId': {
      id: '/_authed/$companySlug/admin/sourcing/websites/$websiteId'
      path: '/sourcing/websites/$websiteId'
      fullPath: '/$companySlug/admin/sourcing/websites/$websiteId'
      preLoaderRoute: typeof AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRouteImport
      parentRoute: typeof AuthedCompanySlugAdminRoute
    }
    '/_authed/$companySlug/_settings/settings/users/$userId/': {
      id: '/_authed/$companySlug/_settings/settings/users/$userId/'
      path: '/settings/users/$userId'
      fullPath: '/$companySlug/settings/users/$userId/'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsUsersUserIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
    '/_authed/$companySlug/_settings/settings/workflows/$workflowId/': {
      id: '/_authed/$companySlug/_settings/settings/workflows/$workflowId/'
      path: '/settings/workflows/$workflowId'
      fullPath: '/$companySlug/settings/workflows/$workflowId/'
      preLoaderRoute: typeof AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugSettingsRoute
    }
  }
}

interface AuthedCompanySlugSettingsRouteChildren {
  AuthedCompanySlugSettingsSettingsApiRoute: typeof AuthedCompanySlugSettingsSettingsApiRoute
  AuthedCompanySlugSettingsSettingsCompanyRoute: typeof AuthedCompanySlugSettingsSettingsCompanyRoute
  AuthedCompanySlugSettingsSettingsIntegrationsRoute: typeof AuthedCompanySlugSettingsSettingsIntegrationsRoute
  AuthedCompanySlugSettingsSettingsLabelsRoute: typeof AuthedCompanySlugSettingsSettingsLabelsRoute
  AuthedCompanySlugSettingsSettingsMcpRoute: typeof AuthedCompanySlugSettingsSettingsMcpRoute
  AuthedCompanySlugSettingsSettingsNotificationsRoute: typeof AuthedCompanySlugSettingsSettingsNotificationsRoute
  AuthedCompanySlugSettingsSettingsProfileRoute: typeof AuthedCompanySlugSettingsSettingsProfileRoute
  AuthedCompanySlugSettingsSettingsRejectionReasonRoute: typeof AuthedCompanySlugSettingsSettingsRejectionReasonRoute
  AuthedCompanySlugSettingsSettingsTeamsRoute: typeof AuthedCompanySlugSettingsSettingsTeamsRoute
  AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute: typeof AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute
  AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute: typeof AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute
  AuthedCompanySlugSettingsSettingsUsersIndexRoute: typeof AuthedCompanySlugSettingsSettingsUsersIndexRoute
  AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute: typeof AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute
  AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute: typeof AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute
  AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute: typeof AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute
}

const AuthedCompanySlugSettingsRouteChildren: AuthedCompanySlugSettingsRouteChildren =
  {
    AuthedCompanySlugSettingsSettingsApiRoute:
      AuthedCompanySlugSettingsSettingsApiRoute,
    AuthedCompanySlugSettingsSettingsCompanyRoute:
      AuthedCompanySlugSettingsSettingsCompanyRoute,
    AuthedCompanySlugSettingsSettingsIntegrationsRoute:
      AuthedCompanySlugSettingsSettingsIntegrationsRoute,
    AuthedCompanySlugSettingsSettingsLabelsRoute:
      AuthedCompanySlugSettingsSettingsLabelsRoute,
    AuthedCompanySlugSettingsSettingsMcpRoute:
      AuthedCompanySlugSettingsSettingsMcpRoute,
    AuthedCompanySlugSettingsSettingsNotificationsRoute:
      AuthedCompanySlugSettingsSettingsNotificationsRoute,
    AuthedCompanySlugSettingsSettingsProfileRoute:
      AuthedCompanySlugSettingsSettingsProfileRoute,
    AuthedCompanySlugSettingsSettingsRejectionReasonRoute:
      AuthedCompanySlugSettingsSettingsRejectionReasonRoute,
    AuthedCompanySlugSettingsSettingsTeamsRoute:
      AuthedCompanySlugSettingsSettingsTeamsRoute,
    AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute:
      AuthedCompanySlugSettingsSettingsSubscriptionCreditHistoryRoute,
    AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute:
      AuthedCompanySlugSettingsSettingsSubscriptionIndexRoute,
    AuthedCompanySlugSettingsSettingsUsersIndexRoute:
      AuthedCompanySlugSettingsSettingsUsersIndexRoute,
    AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute:
      AuthedCompanySlugSettingsSettingsWorkflowsIndexRoute,
    AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute:
      AuthedCompanySlugSettingsSettingsUsersUserIdIndexRoute,
    AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute:
      AuthedCompanySlugSettingsSettingsWorkflowsWorkflowIdIndexRoute,
  }

const AuthedCompanySlugSettingsRouteWithChildren =
  AuthedCompanySlugSettingsRoute._addFileChildren(
    AuthedCompanySlugSettingsRouteChildren,
  )

interface AuthedCompanySlugAdminClientsRouteChildren {
  AuthedCompanySlugAdminClientsClientIdRoute: typeof AuthedCompanySlugAdminClientsClientIdRoute
  AuthedCompanySlugAdminClientsIndexRoute: typeof AuthedCompanySlugAdminClientsIndexRoute
}

const AuthedCompanySlugAdminClientsRouteChildren: AuthedCompanySlugAdminClientsRouteChildren =
  {
    AuthedCompanySlugAdminClientsClientIdRoute:
      AuthedCompanySlugAdminClientsClientIdRoute,
    AuthedCompanySlugAdminClientsIndexRoute:
      AuthedCompanySlugAdminClientsIndexRoute,
  }

const AuthedCompanySlugAdminClientsRouteWithChildren =
  AuthedCompanySlugAdminClientsRoute._addFileChildren(
    AuthedCompanySlugAdminClientsRouteChildren,
  )

interface AuthedCompanySlugAdminUsersRouteChildren {
  AuthedCompanySlugAdminUsersIndexRoute: typeof AuthedCompanySlugAdminUsersIndexRoute
}

const AuthedCompanySlugAdminUsersRouteChildren: AuthedCompanySlugAdminUsersRouteChildren =
  {
    AuthedCompanySlugAdminUsersIndexRoute:
      AuthedCompanySlugAdminUsersIndexRoute,
  }

const AuthedCompanySlugAdminUsersRouteWithChildren =
  AuthedCompanySlugAdminUsersRoute._addFileChildren(
    AuthedCompanySlugAdminUsersRouteChildren,
  )

interface AuthedCompanySlugAdminRouteChildren {
  AuthedCompanySlugAdminAccessCreditsRoute: typeof AuthedCompanySlugAdminAccessCreditsRoute
  AuthedCompanySlugAdminCategoryImagesRoute: typeof AuthedCompanySlugAdminCategoryImagesRoute
  AuthedCompanySlugAdminClientsRoute: typeof AuthedCompanySlugAdminClientsRouteWithChildren
  AuthedCompanySlugAdminFeatureFlagsRoute: typeof AuthedCompanySlugAdminFeatureFlagsRoute
  AuthedCompanySlugAdminUsersRoute: typeof AuthedCompanySlugAdminUsersRouteWithChildren
  AuthedCompanySlugAdminIndexRoute: typeof AuthedCompanySlugAdminIndexRoute
  AuthedCompanySlugAdminProcurementCalendarNewRoute: typeof AuthedCompanySlugAdminProcurementCalendarNewRoute
  AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute: typeof AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute
  AuthedCompanySlugAdminSourcingEntriesIndexRoute: typeof AuthedCompanySlugAdminSourcingEntriesIndexRoute
  AuthedCompanySlugAdminSourcingOverviewIndexRoute: typeof AuthedCompanySlugAdminSourcingOverviewIndexRoute
  AuthedCompanySlugAdminSourcingReviewIndexRoute: typeof AuthedCompanySlugAdminSourcingReviewIndexRoute
  AuthedCompanySlugAdminSourcingWebsitesIndexRoute: typeof AuthedCompanySlugAdminSourcingWebsitesIndexRoute
}

const AuthedCompanySlugAdminRouteChildren: AuthedCompanySlugAdminRouteChildren =
  {
    AuthedCompanySlugAdminAccessCreditsRoute:
      AuthedCompanySlugAdminAccessCreditsRoute,
    AuthedCompanySlugAdminCategoryImagesRoute:
      AuthedCompanySlugAdminCategoryImagesRoute,
    AuthedCompanySlugAdminClientsRoute:
      AuthedCompanySlugAdminClientsRouteWithChildren,
    AuthedCompanySlugAdminFeatureFlagsRoute:
      AuthedCompanySlugAdminFeatureFlagsRoute,
    AuthedCompanySlugAdminUsersRoute:
      AuthedCompanySlugAdminUsersRouteWithChildren,
    AuthedCompanySlugAdminIndexRoute: AuthedCompanySlugAdminIndexRoute,
    AuthedCompanySlugAdminProcurementCalendarNewRoute:
      AuthedCompanySlugAdminProcurementCalendarNewRoute,
    AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute:
      AuthedCompanySlugAdminSourcingWebsitesWebsiteIdRoute,
    AuthedCompanySlugAdminSourcingEntriesIndexRoute:
      AuthedCompanySlugAdminSourcingEntriesIndexRoute,
    AuthedCompanySlugAdminSourcingOverviewIndexRoute:
      AuthedCompanySlugAdminSourcingOverviewIndexRoute,
    AuthedCompanySlugAdminSourcingReviewIndexRoute:
      AuthedCompanySlugAdminSourcingReviewIndexRoute,
    AuthedCompanySlugAdminSourcingWebsitesIndexRoute:
      AuthedCompanySlugAdminSourcingWebsitesIndexRoute,
  }

const AuthedCompanySlugAdminRouteWithChildren =
  AuthedCompanySlugAdminRoute._addFileChildren(
    AuthedCompanySlugAdminRouteChildren,
  )

interface AuthedCompanySlugRouteChildren {
  AuthedCompanySlugSettingsRoute: typeof AuthedCompanySlugSettingsRouteWithChildren
  AuthedCompanySlugAdminRoute: typeof AuthedCompanySlugAdminRouteWithChildren
  AuthedCompanySlugIntelligenceRoute: typeof AuthedCompanySlugIntelligenceRoute
  AuthedCompanySlugTasksRoute: typeof AuthedCompanySlugTasksRoute
  AuthedCompanySlugIndexRoute: typeof AuthedCompanySlugIndexRoute
  AuthedCompanySlugCaselawIndexRoute: typeof AuthedCompanySlugCaselawIndexRoute
  AuthedCompanySlugHorizonIndexRoute: typeof AuthedCompanySlugHorizonIndexRoute
  AuthedCompanySlugOrganisationsIndexRoute: typeof AuthedCompanySlugOrganisationsIndexRoute
  AuthedCompanySlugOrganizationsIndexRoute: typeof AuthedCompanySlugOrganizationsIndexRoute
  AuthedCompanySlugProcurementCalendarIndexRoute: typeof AuthedCompanySlugProcurementCalendarIndexRoute
  AuthedCompanySlugTendersIndexRoute: typeof AuthedCompanySlugTendersIndexRoute
  AuthedCompanySlugWorkflowsIndexRoute: typeof AuthedCompanySlugWorkflowsIndexRoute
  AuthedCompanySlugCaselawCaselawIdIndexRoute: typeof AuthedCompanySlugCaselawCaselawIdIndexRoute
  AuthedCompanySlugHorizonItemIdIndexRoute: typeof AuthedCompanySlugHorizonItemIdIndexRoute
  AuthedCompanySlugOrganisationsOrganizationIdIndexRoute: typeof AuthedCompanySlugOrganisationsOrganizationIdIndexRoute
  AuthedCompanySlugOrganizationsOrganizationIdIndexRoute: typeof AuthedCompanySlugOrganizationsOrganizationIdIndexRoute
  AuthedCompanySlugTendersTenderIdIndexRoute: typeof AuthedCompanySlugTendersTenderIdIndexRoute
}

const AuthedCompanySlugRouteChildren: AuthedCompanySlugRouteChildren = {
  AuthedCompanySlugSettingsRoute: AuthedCompanySlugSettingsRouteWithChildren,
  AuthedCompanySlugAdminRoute: AuthedCompanySlugAdminRouteWithChildren,
  AuthedCompanySlugIntelligenceRoute: AuthedCompanySlugIntelligenceRoute,
  AuthedCompanySlugTasksRoute: AuthedCompanySlugTasksRoute,
  AuthedCompanySlugIndexRoute: AuthedCompanySlugIndexRoute,
  AuthedCompanySlugCaselawIndexRoute: AuthedCompanySlugCaselawIndexRoute,
  AuthedCompanySlugHorizonIndexRoute: AuthedCompanySlugHorizonIndexRoute,
  AuthedCompanySlugOrganisationsIndexRoute:
    AuthedCompanySlugOrganisationsIndexRoute,
  AuthedCompanySlugOrganizationsIndexRoute:
    AuthedCompanySlugOrganizationsIndexRoute,
  AuthedCompanySlugProcurementCalendarIndexRoute:
    AuthedCompanySlugProcurementCalendarIndexRoute,
  AuthedCompanySlugTendersIndexRoute: AuthedCompanySlugTendersIndexRoute,
  AuthedCompanySlugWorkflowsIndexRoute: AuthedCompanySlugWorkflowsIndexRoute,
  AuthedCompanySlugCaselawCaselawIdIndexRoute:
    AuthedCompanySlugCaselawCaselawIdIndexRoute,
  AuthedCompanySlugHorizonItemIdIndexRoute:
    AuthedCompanySlugHorizonItemIdIndexRoute,
  AuthedCompanySlugOrganisationsOrganizationIdIndexRoute:
    AuthedCompanySlugOrganisationsOrganizationIdIndexRoute,
  AuthedCompanySlugOrganizationsOrganizationIdIndexRoute:
    AuthedCompanySlugOrganizationsOrganizationIdIndexRoute,
  AuthedCompanySlugTendersTenderIdIndexRoute:
    AuthedCompanySlugTendersTenderIdIndexRoute,
}

const AuthedCompanySlugRouteWithChildren =
  AuthedCompanySlugRoute._addFileChildren(AuthedCompanySlugRouteChildren)

interface AuthedNoSidebarCompanySlugRouteChildren {
  AuthedNoSidebarCompanySlugUpgradeRoute: typeof AuthedNoSidebarCompanySlugUpgradeRoute
  AuthedNoSidebarCompanySlugSubscribeCallbackRoute: typeof AuthedNoSidebarCompanySlugSubscribeCallbackRoute
  AuthedNoSidebarCompanySlugSubscribeFailedRoute: typeof AuthedNoSidebarCompanySlugSubscribeFailedRoute
  AuthedNoSidebarCompanySlugSubscribeOverdueRoute: typeof AuthedNoSidebarCompanySlugSubscribeOverdueRoute
  AuthedNoSidebarCompanySlugSubscribeSuccessRoute: typeof AuthedNoSidebarCompanySlugSubscribeSuccessRoute
  AuthedNoSidebarCompanySlugSubscribeIndexRoute: typeof AuthedNoSidebarCompanySlugSubscribeIndexRoute
}

const AuthedNoSidebarCompanySlugRouteChildren: AuthedNoSidebarCompanySlugRouteChildren =
  {
    AuthedNoSidebarCompanySlugUpgradeRoute:
      AuthedNoSidebarCompanySlugUpgradeRoute,
    AuthedNoSidebarCompanySlugSubscribeCallbackRoute:
      AuthedNoSidebarCompanySlugSubscribeCallbackRoute,
    AuthedNoSidebarCompanySlugSubscribeFailedRoute:
      AuthedNoSidebarCompanySlugSubscribeFailedRoute,
    AuthedNoSidebarCompanySlugSubscribeOverdueRoute:
      AuthedNoSidebarCompanySlugSubscribeOverdueRoute,
    AuthedNoSidebarCompanySlugSubscribeSuccessRoute:
      AuthedNoSidebarCompanySlugSubscribeSuccessRoute,
    AuthedNoSidebarCompanySlugSubscribeIndexRoute:
      AuthedNoSidebarCompanySlugSubscribeIndexRoute,
  }

const AuthedNoSidebarCompanySlugRouteWithChildren =
  AuthedNoSidebarCompanySlugRoute._addFileChildren(
    AuthedNoSidebarCompanySlugRouteChildren,
  )

interface AuthedNoSidebarRouteChildren {
  AuthedNoSidebarCompanySlugRoute: typeof AuthedNoSidebarCompanySlugRouteWithChildren
}

const AuthedNoSidebarRouteChildren: AuthedNoSidebarRouteChildren = {
  AuthedNoSidebarCompanySlugRoute: AuthedNoSidebarCompanySlugRouteWithChildren,
}

const AuthedNoSidebarRouteWithChildren = AuthedNoSidebarRoute._addFileChildren(
  AuthedNoSidebarRouteChildren,
)

interface AuthedRouteChildren {
  AuthedCompanySlugRoute: typeof AuthedCompanySlugRouteWithChildren
  AuthedNoSidebarRoute: typeof AuthedNoSidebarRouteWithChildren
  AuthedDiscoverRoute: typeof AuthedDiscoverRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCompanySlugRoute: AuthedCompanySlugRouteWithChildren,
  AuthedNoSidebarRoute: AuthedNoSidebarRouteWithChildren,
  AuthedDiscoverRoute: AuthedDiscoverRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface AuthRouteChildren {
  AuthAccountsRoute: typeof AuthAccountsRoute
  AuthJoinRoute: typeof AuthJoinRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountsRoute: AuthAccountsRoute,
  AuthJoinRoute: AuthJoinRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ShareRouteChildren {
  ShareTenderTokenRoute: typeof ShareTenderTokenRoute
}

const ShareRouteChildren: ShareRouteChildren = {
  ShareTenderTokenRoute: ShareTenderTokenRoute,
}

const ShareRouteWithChildren = ShareRoute._addFileChildren(ShareRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ShareRoute: ShareRouteWithChildren,
  OnboardingCompanySetupRoute: OnboardingCompanySetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
